export default {
	teacherProfile: "Teacher Information",
	teacherHome: "Creator Profile",
	search: "Search",
	likes: "Likes",
	followers: "Followers",
	follow: "Follow",
	followed: "Following",
	privateChat: "Message",
	breadcrumb: "Teacher Information",
	teacherIntro: "Teacher Introduction",
	yearsExperience: "Experience",
	serviceCount: "Clients served",
	rating: "Reviews",
	freeConsult: "Free Try",
	freeAssistantConsult: "Free assistant consultation",
	share: "Share",
	privacyTitle: "Privacy Protection",
	privacyDesc:
		"Use encryption technology to ensure the security of your personal information and consultation content",
	sections: {
		consultService: "Consulting Service",
		solutionService: "Solutions",
		media: "Media",
		userEvaluate: "Consultation reviews",
	},
	consultList: "Consulting Service",
	solutionList: "Solutions",
	mediaList: "Media content",
	evaluateList: "Consultation reviews",
	originalPrice: "Original {price} points",
	finalPrice: "Final price",
	orderNow: "Order Now",
	serviceOrder: "Order Now",
	coinAlt: "Points",
	mediaShorts: "Shorts",
	mediaCourses: "Courses",
	mediaVideo: "Videos",
	mediaArticle: "Articles",
	mediaViewCount: "{count} views",
	mediaEmpty: "No media yet",
	mediaVideoEmpty: "No videos yet",
	mediaArticleEmpty: "No articles yet",
	noData: "No data",
	anonymousUser: "Anonymous User",
	prevPage: "Previous",
	nextPage: "Next",
};
